module.exports = __webpack_public_path__ + "static/media/production2.175987d1.jpg";